var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"pl-1 pb-1 pb-md-0"},[_c('v-row',{staticClass:"ml-0 pl-0",attrs:{"align-start":"","justify-start":"","fill-height":""}},[_c('span',{staticClass:"ml-0 text-body-2 text-md-caption"},[_vm._v(_vm._s(_vm.thesis.department)+" "+_vm._s(_vm.thesis.year_start))])])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }